import React from 'react';

import { Row } from '@tanstack/react-table';

import { ReportList } from 'api/endPoints/getReportList';

import { FAVORITES } from 'components/Dashboards/Reporting/reporting.consts';

import { DynamicChipsCell } from '../DynamicChipsCell/DynamicChipsCell';

interface Props {
    row: Row<ReportList>;
}

export const ReportTagsCell = ({ row }: Props) => {
    const tagsNames = row.original?.tags?.map((tag) => tag.name).filter((tag) => tag !== FAVORITES) ?? [];
    return tagsNames.length > 0 ? <DynamicChipsCell list={tagsNames} type={'default'} /> : null;
};
